import type { TermsData } from './terms.types';

const data: TermsData = {
  seo: {
    title: 'លក្ខខណ្ឌនៃការប្រើប្រាស់ | E-School Cambodia',
    description: 'អានលក្ខខណ្ឌនៃការប្រើប្រាស់សម្រាប់ចូលប្រើប្រាស់ និងប្រើប្រាស់សេវាកម្មអប់រំរបស់ E-School Cambodia។',
  },
  hero: {
    badge: 'ឯកសារផ្លូវការ',
    title: 'លក្ខខណ្ឌនៃការប្រើប្រាស់',
    subtitle: 'សម្រាប់សិស្ស និងមាតាបិតា/អ្នកអាណាព្យាបាល',
  },
  intro: {
    text: 'លក្ខខណ្ឌនៃការប្រើប្រាស់ទាំងនេះពិពណ៌នាអំពីច្បាប់សម្រាប់ការចូលប្រើប្រាស់ និងការប្រើប្រាស់សេវាកម្មអប់រំរបស់ E-School។<br/><br/>លក្ខខណ្ឌទាំងនេះអនុវត្តចំពោះសិស្ស និងមាតាបិតា/អ្នកអាណាព្យាបាលដែលប្រើប្រាស់កម្មវិធី គេហទំព័រ និងសេវាកម្មពាក់ព័ន្ធរបស់ E-School។<br/><br/>តាមរយៈការចូលប្រើប្រាស់ ឬការប្រើប្រាស់ E-School អ្នកយល់ព្រមអនុវត្តតាមលក្ខខណ្ឌនៃការប្រើប្រាស់ទាំងនេះ។',
  },
  sections: [
    {
      number: '១',
      title: 'ការប្រើប្រាស់ E-School',
      paragraphs: [
        'សិស្សអាចប្រើប្រាស់ E-School សម្រាប់សកម្មភាពអប់រំដែលទទួលបានការអនុញ្ញាត រួមមាន៖',
        '• ការចូលរួមថ្នាក់រៀនផ្ទាល់ (Live classes);',
        '• ការទស្សនាវីដេអូមេរៀនដែលបានថតទុក;',
        '• ការចូលរៀនវគ្គសិក្សា និងកម្មវិធីសិក្សា;',
        '• ការអាន និងការប្រើប្រាស់សម្ភារបណ្ណាល័យ;',
        '• ការធ្វើតេស្ត QCM/តេស្តជ្រើសរើសចម្លើយច្រើន;',
        '• ការបំពេញកម្រងសំណួរ លំហាត់ និងការវាយតម្លៃ;',
        '• ការប្រាស្រ័យទាក់ទងជាមួយគ្រូ និងអ្នកប្រើប្រាស់ដែលទទួលបានការអនុញ្ញាត;',
        '• ការពិនិត្យមើលវឌ្ឍនភាពនៃការសិក្សា;',
        '• ការពិនិត្យមើលវត្តមាន;',
        '• ការមើលលទ្ធផលតេស្ត;',
        '• ការមើលរបាយការណ៍សិក្សា;',
        '• ការទទួលបានការជូនដំណឹង និងការប្រកាសព័ត៌មានអប់រំ; និង',
        '• ការប្រើប្រាស់មុខងារសិក្សាផ្សេងទៀតដែលមាន។',
        'មាតាបិតា/អ្នកអាណាព្យាបាលក៏អាចប្រើប្រាស់មុខងារអប់រំដែលមានសម្រាប់គណនីរបស់ពួកគេផងដែរ ហើយអាចចូលមើលព័ត៌មានពាក់ព័ន្ធនឹងកូនៗដែលបានភ្ជាប់គណនី និងទទួលបានការអនុញ្ញាតរបស់ពួកគេ។',
      ],
    },
    {
      number: '២',
      title: 'គណនីរបស់អ្នក',
      paragraphs: [
        'អ្នកត្រូវតែប្រើប្រាស់គណនីដែលអ្នកទទួលបានការអនុញ្ញាតក្នុងការចូលប្រើប្រាស់។',
        'អ្នកមិនត្រូវ៖',
        '• ចែករំលែកពាក្យសម្ងាត់ ឬព័ត៌មានផ្ទៀងផ្ទាត់ភាពត្រឹមត្រូវរបស់អ្នកជាមួយមនុស្សដែលមិនទទួលបានការអនុញ្ញាតឡើយ;',
        '• លក់ ជួល ឱ្យខ្ចី ឬផ្ទេរគណនីរបស់អ្នក;',
        '• ប្រើប្រាស់គណនីរបស់សិស្សផ្សេងទៀត;',
        '• បន្លំធ្វើជាអ្នកប្រើប្រាស់ផ្សេង;',
        '• ព្យាយាមស្វែងរកការអនុញ្ញាតដែលមិនមានសិទ្ធិ; ឬ',
        '• ព្យាយាមចូលមើលព័ត៌មានឯកជនរបស់អ្នកប្រើប្រាស់ផ្សេងទៀត។',
        'ប្រសិនបើអ្នកជឿថាគណនីរបស់អ្នកត្រូវបានចូលប្រើប្រាស់ដោយគ្មានការអនុញ្ញាត អ្នកគួរតែជូនដំណឹងដល់ E-School។',
      ],
    },
    {
      number: '៣',
      title: 'ការចូលប្រើប្រាស់របស់មាតាបិតា/អ្នកអាណាព្យាបាល',
      paragraphs: [
        'E-School អាចអនុញ្ញាតឱ្យមាតាបិតា/អ្នកអាណាព្យាបាលភ្ជាប់គណនីរបស់ពួកគេទៅនឹងគណនី E-School របស់កូនពួកគេ។',
        'នៅពេលភ្ជាប់បានត្រឹមត្រូវហើយ មាតាបិតា/អ្នកអាណាព្យាបាលអាចមើលឃើញព័ត៌មានដូចជា៖',
        '• វគ្គសិក្សា និងកម្មវិធីសិក្សា;',
        '• សកម្មភាពសិក្សា;',
        '• វឌ្ឍនភាពនៃការសិក្សា;',
        '• វត្តមាន;',
        '• លទ្ធផល QCM និងលទ្ធផលតេស្ត;',
        '• ពិន្ទុ;',
        '• របាយការណ៍សិក្សា; និង',
        '• ព័ត៌មានអប់រំផ្សេងទៀត។',
        'មាតាបិតា/អ្នកអាណាព្យាបាលត្រូវចូលមើលព័ត៌មានរបស់កូនតែក្នុងករណីដែលពួកគេទទួលបានការអនុញ្ញាតប៉ុណ្ណោះ។',
        'E-School អាចតម្រូវឱ្យមានការផ្ទៀងផ្ទាត់មុនពេលបង្កើត ឬផ្លាស់ប្តូរទំនាក់ទំនងរវាងមាតាបិតា និងកូន។',
      ],
    },
    {
      number: '៤',
      title: 'ការចូលរៀនវគ្គសិក្សា',
      paragraphs: [
        'មិនមែនគ្រប់គណនី E-School ទាំងអស់សុទ្ធតែមានសិទ្ធិចូលរៀនគ្រប់វគ្គសិក្សា ឬសេវាកម្មសិក្សានោះទេ។',
        'ការចូលរៀនអាចអាស្រ័យលើ៖',
        '• ការចុះឈ្មោះចូលរៀន;',
        '• ថ្នាក់សិក្សា;',
        '• មុខវិជ្ជា;',
        '• កម្មវិធីសិក្សា;',
        '• ស្ថានភាពគណនី;',
        '• សាលារៀន ឬគ្រឹះស្ថានសិក្សា;',
        '• រយៈពេលនៃការចូលប្រើប្រាស់;',
        '• គម្រោងសេវាកម្មដែលអាចអនុវត្តបាន; ឬ',
        '• ការអនុញ្ញាតផ្សេងទៀតដែលផ្តល់ដោយ E-School។',
        'អ្នកប្រើប្រាស់មិនត្រូវព្យាយាមគេចវេះពីការរឹតបន្តឹងសិទ្ធិចូលប្រើប្រាស់ទាំងនេះឡើយ។',
        'សេវាកម្មខ្លះអាចឥតគិតថ្លៃ ខណៈពេលដែលសេវាកម្មខ្លះទៀតអាចតម្រូវឱ្យមានការចុះឈ្មោះ ការបង់ប្រាក់ ការជាវប្រចាំ ឬការអនុញ្ញាតផ្សេងទៀត។',
      ],
    },
    {
      number: '៥',
      title: 'ថ្នាក់រៀនផ្ទាល់ (Live Classes)',
      paragraphs: [
        'សិស្សអាចចូលរួមថ្នាក់រៀនផ្ទាល់សម្រាប់វគ្គសិក្សាដែលពួកគេទទួលបានការអនុញ្ញាតឱ្យចូលរួម។',
        'សិស្សគួរតែ៖',
        '• ចូលរួមដោយប្រើប្រាស់គណនីផ្ទាល់ខ្លួនដែលទទួលបានការអនុញ្ញាត;',
        '• អនុវត្តតាមច្បាប់ក្នុងថ្នាក់រៀន;',
        '• គោរពគ្រូបង្រៀន;',
        '• គោរពសិស្សដទៃទៀត;',
        '• ប្រើប្រាស់មុខងារទំនាក់ទំនងឱ្យបានសមស្រប; និង',
        '• ចៀសវាងអាកប្បកិរិយាទាំងឡាយណាដែលរំខានដល់ថ្នាក់រៀន។',
        'តំណភ្ជាប់ថ្នាក់រៀនផ្ទាល់, លេខសម្គាល់ការប្រជុំ (meeting IDs), លេខកូដសម្ងាត់ (passcodes), ការអញ្ជើញ ឬព័ត៌មានចូលប្រើប្រាស់ដែលត្រូវបានការពារផ្សេងទៀត មិនត្រូវចែករំលែកជាមួយមនុស្សដែលមិនទទួលបានការអនុញ្ញាតឡើយ។',
        'ការមានព័ត៌មានចូលរៀនថ្នាក់ផ្ទាល់ មិនប្រាកដថាបុគ្គលនោះទទួលបានការអនុញ្ញាតឱ្យចូលរួមនោះទេ។',
        'E-School អាចផ្ទៀងផ្ទាត់ថាតើអ្នកចូលរួមទទួលបានការអនុញ្ញាតដែរឬទេ ហើយអាចបដិសេធ ឬលុបអ្នកចូលរួមដែលគ្មានការអនុញ្ញាតចេញ។',
      ],
    },
    {
      number: '៦',
      title: 'វីដេអូមេរៀន',
      paragraphs: [
        'វីដេអូមេរៀនត្រូវបានផ្តល់ជូនសម្រាប់ការប្រើប្រាស់ក្នុងគោលបំណងអប់រំដែលទទួលបានការអនុញ្ញាត។',
        'លើកលែងតែទទួលបានការអនុញ្ញាតជាក់លាក់ពី E-School អ្នកប្រើប្រាស់មិនត្រូវ៖',
        '• ទាញយកវីដេអូដែលត្រូវបានការពារដោយប្រើប្រាស់វិធីសាស្ត្រដែលមិនទទួលបានការអនុញ្ញាត;',
        '• ចម្លងវីដេអូដែលត្រូវបានការពារ;',
        '• បញ្ចូល (upload) វីដេអូទាំងនោះទៅកាន់បណ្តាញ ឬផ្លតហ្វមផ្សេងទៀត;',
        '• លក់ ឬចែកចាយវីដេអូទាំងនោះឡើងវិញ;',
        '• ចែករំលែកសិទ្ធិចូលមើលដែលត្រូវបានការពារជាមួយបុគ្គលដែលគ្មានការអនុញ្ញាត; ឬ',
        '• គេចវេះ ឬបំពានលើការការពារបច្ចេកវិទ្យា។',
      ],
    },
    {
      number: '៧',
      title: 'បណ្ណាល័យ',
      paragraphs: [
        'បណ្ណាល័យឌីជីថលរបស់ E-School អាចផ្តល់នូវឯកសារអប់រំរួមមាន សៀវភៅ ឯកសារ PDFs សន្លឹកកិច្ចការ កំណត់ត្រាមេរៀន រូបភាព និងធនធានផ្សេងៗទៀត។',
        'ឯកសារមួយចំនួនអាចមានសម្រាប់តែវគ្គសិក្សា ថ្នាក់សិក្សា មុខវិជ្ជា កម្មវិធីសិក្សា ឬអ្នកប្រើប្រាស់ជាក់លាក់ប៉ុណ្ណោះ។',
        'អ្នកប្រើប្រាស់អាចចូលមើល និងប្រើប្រាស់ឯកសារបានត្រឹមតែកម្រិតដែលត្រូវបានអនុញ្ញាតដោយ E-School និងសិទ្ធិមាតិកាដែលអាចអនុវត្តបានប៉ុណ្ណោះ។',
        'មាតិកាបណ្ណាល័យ E-School ដែលត្រូវបានការពារមិនត្រូវចែកចាយក្នុងគោលបំណងពាណិជ្ជកម្មដោយគ្មានការអនុញ្ញាតឡើយ។',
      ],
    },
    {
      number: '៨',
      title: 'QCM តេស្ត និងការវាយតម្លៃ',
      paragraphs: [
        'សិស្សគួរតែបំពេញការធ្វើតេស្ត និងការវាយតម្លៃដោយស្មោះត្រង់។',
        'សិស្សមិនត្រូវ៖',
        '• ឱ្យអ្នកដទៃធ្វើតេស្តជំនួសខ្លួន;',
        '• ធ្វើតេស្តដោយប្រើប្រាស់អត្តសញ្ញាណរបស់សិស្សផ្សេងទៀត;',
        '• ក្លែងបន្លំពិន្ទុ ឬលទ្ធផលរបស់ពួកគេ;',
        '• ព្យាយាមកែប្រែលទ្ធផលដែលបានរក្សាទុក;',
        '• ទាញយកផលប្រយោជន៍ពីកំហុសប្រព័ន្ធ (system errors) ដើម្បីទទួលបានចម្លើយ ឬអត្ថប្រយោជន៍មិនស្មោះត្រង់; ឬ',
        '• រំខាន ឬជ្រៀតជ្រែកក្នុងប្រព័ន្ធធ្វើតេស្ត។',
        'E-School អាចកត់ត្រាទុកនូវការប៉ុនប៉ងធ្វើតេស្ត ចម្លើយ ពិន្ទុ ព័ត៌មាននៃការបំពេញតេស្ត និងសកម្មភាពអប់រំដែលពាក់ព័ន្ធ សម្រាប់គោលបំណងអប់រំ និងការធ្វើរបាយការណ៍។',
      ],
    },
    {
      number: '៩',
      title: 'ការប្រាស្រ័យទាក់ទង',
      paragraphs: [
        'មុខងារទំនាក់ទំនងគឺត្រូវបានបង្កើតឡើងដើម្បីគាំទ្រដល់ការអប់រំ និងការប្រាស្រ័យទាក់ទងគ្នាប្រកបដោយភាពសមស្របរវាងអ្នកប្រើប្រាស់ដែលទទួលបានការអនុញ្ញាត។',
        'អ្នកប្រើប្រាស់គួរតែធ្វើការប្រាស្រ័យទាក់ទងដោយការគោរពជាមួយ៖',
        '• គ្រូបង្រៀន;',
        '• សិស្សដទៃទៀត;',
        '• បុគ្គលិកគាំទ្ររបស់ E-School; និង',
        '• អ្នកប្រើប្រាស់ដែលទទួលបានការអនុញ្ញាតផ្សេងទៀត។',
        'អ្នកប្រើប្រាស់មិនត្រូវផ្ញើ ឬបញ្ជូន (upload)៖',
        '• មាតិកាគំរាមកំហែង ឬជេរប្រមាថ;',
        '• ការធ្វើទុក្ខបុកម្នេញ ឬការបៀតបៀន (Bullying or harassment);',
        '• មាតិកាមិនសមរម្យផ្នែកផ្លូវភេទ;',
        '• ឯកសារ ឬសម្ភារខុសច្បាប់;',
        '• សារឥតបានការ (Spam);',
        '• ឯកសារដែលមានផ្ទុកមេរោគ ឬកូដព្យាបាទ (Malicious files);',
        '• ព័ត៌មានក្លែងបន្លំ ឬបោកប្រាស់;',
        '• មាតិកាដែលរំលោភលើសិទ្ធិឯកជនភាពរបស់អ្នកដទៃ; ឬ',
        '• មាតិកាដែលរំលោភលើសិទ្ធិរបស់អ្នកដទៃ។',
        'E-School អាចស៊ើបអង្កេតលើមាតិកាដែលត្រូវបានរាយការណ៍ និងចាត់វិធានការសមស្រប។',
      ],
    },
    {
      number: '១០',
      title: 'របាយការណ៍សិក្សា',
      paragraphs: [
        'E-School អាចបង្កើតរបាយការណ៍ដោយផ្អែកលើសកម្មភាពសិក្សារបស់សិស្ស។',
        'របាយការណ៍អាចមានព័ត៌មានដូចជា៖',
        '• វឌ្ឍនភាពនៃវគ្គសិក្សា;',
        '• មេរៀនដែលបានរៀនរួច;',
        '• សកម្មភាពសិក្សាតាមរយៈវីដេអូ;',
        '• វត្តមាននៅក្នុងថ្នាក់រៀនផ្ទាល់;',
        '• លទ្ធផលតេស្ត និងលទ្ធផល QCM;',
        '• ពិន្ទុ;',
        '• សកម្មភាពសិក្សានានា; និង',
        '• សូចនាករអប់រំផ្សេងទៀត។',
        'សិស្សអាចចូលមើលរបាយការណ៍ផ្ទាល់ខ្លួនរបស់ពួកគេបាន។',
        'មាតាបិតា/អ្នកអាណាព្យាបាលដែលទទួលបានការអនុញ្ញាតអាចចូលមើលរបាយការណ៍សម្រាប់កូនៗដែលបានភ្ជាប់គណនីរបស់ពួកគេ។',
        'របាយការណ៍សិក្សាគឺមានបំណងជួយសិស្ស និងមាតាបិតា/អ្នកអាណាព្យាបាលឱ្យយល់ដឹងអំពីសកម្មភាពសិក្សា និងវឌ្ឍនភាពសិក្សា។ របាយការណ៍ទាំងនេះមិនមែនជាការធានាចំពោះលទ្ធផលសិក្សានាពេលអនាគតនោះទេ។',
      ],
    },
    {
      number: '១១',
      title: 'ការគោរពសិទ្ធិឯកជនភាព',
      paragraphs: [
        'អ្នកប្រើប្រាស់ត្រូវតែគោរពឯកជនភាពរបស់សិស្ស មាតាបិតា/អ្នកអាណាព្យាបាល គ្រូបង្រៀន និងអ្នកប្រើប្រាស់ E-School ផ្សេងទៀត។',
        'អ្នកប្រើប្រាស់មិនត្រូវ៖',
        '• ព្យាយាមចូលមើលព័ត៌មានឯកជនរបស់អ្នកប្រើប្រាស់ផ្សេងទៀត;',
        '• ចែករំលែកព័ត៌មានឯកជនរបស់អ្នកដទៃដោយគ្មានការអនុញ្ញាត;',
        '• ប្រើប្រាស់ព័ត៌មានដែលទទួលបានតាមរយៈ E-School ក្នុងផ្លូវខុស;',
        '• ថតសំឡេង ឬវីដេអូនៃការប្រាស្រ័យទាក់ទងឯកជនដោយគ្មានការអនុញ្ញាត ក្នុងករណីដែលត្រូវបានហាមឃាត់; ឬ',
        '• ប្រើប្រាស់ព័ត៌មានរបស់ E-School ដើម្បីធ្វើទុក្ខបុកម្នេញ ឬបង្កគ្រោះថ្នាក់ដល់អ្នកដទៃ។',
        'មាតាបិតា/អ្នកអាណាព្យាបាលគួរប្រើប្រាស់ព័ត៌មានដែលពាក់ព័ន្ធនឹងកូនៗរបស់ពួកគេដោយការទទួលខុសត្រូវ និងស្របតាមច្បាប់ជាធរមាន។',
      ],
    },
    {
      number: '១២',
      title: 'កម្មសិទ្ធិលើមាតិកា',
      paragraphs: [
        'សម្ភារអប់រំរបស់ E-School អាចជាកម្មសិទ្ធិរបស់ E-School ឬទទួលបានអាជ្ញាប័ណ្ណពីគ្រូបង្រៀន គ្រឹះស្ថានបោះពុម្ពផ្សាយ ដៃគូអប់រំ ឬម្ចាស់មាតិកាផ្សេងទៀត។',
        'ការប្រើប្រាស់ E-School មិនផ្ទេរកម្មសិទ្ធិនៃមាតិកានោះទៅឱ្យអ្នកប្រើប្រាស់ឡើយ។',
        'អ្នកប្រើប្រាស់ទទួលបានត្រឹមតែសិទ្ធិមានកំណត់ក្នុងការចូលមើល និងប្រើប្រាស់មាតិកាស្របតាមសេវាកម្ម E-School និងលក្ខខណ្ឌនៃការចូលប្រើប្រាស់ដែលអាចអនុវត្តបានប៉ុណ្ណោះ។',
      ],
    },
    {
      number: '១៣',
      title: 'តម្លៃសេវាកម្ម និងការចូលប្រើប្រាស់សេវាកម្មបង់ប្រាក់',
      paragraphs: [
        'វគ្គសិក្សា ឬសេវាកម្មមួយចំនួនរបស់ E-School អាចតម្រូវឱ្យមានការបង់ប្រាក់ ឬទម្រង់នៃការចុះឈ្មោះចូលរៀនដែលទទួលបានការអនុញ្ញាតផ្សេងទៀត។',
        'ភាពអាចរកបាននៃសេវាកម្មបង់ប្រាក់ និងមធ្យោបាយទូទាត់ប្រាក់ អាចមានភាពខុសគ្នាទៅតាមបណ្តាញ (platform) ឧបករណ៍ ប្រទេស ឬតំបន់ ប្រភេទគណនី កម្មវិធីសិក្សា ឬកំណែ (version) របស់ E-School។',
        'នៅពេលដែលមានជម្រើសនៃការបង់ប្រាក់ តម្លៃដែលអាចអនុវត្តបាន រយៈពេលនៃការចូលប្រើប្រាស់ លក្ខខណ្ឌនៃការជាវ និងលក្ខខណ្ឌផ្សេងទៀតនឹងត្រូវបានជម្រាបជូនដោយឡែកពីគ្នា។',
        'អ្នកប្រើប្រាស់ដែលទទួលបានសិទ្ធិចូលរៀនវគ្គសិក្សា ឬសេវាកម្មណាមួយរួចហើយ អាចចូលមើលមាតិកានោះតាមរយៈគណនី E-School របស់ពួកគេ ដោយអនុលោមតាមលក្ខខណ្ឌចូលប្រើប្រាស់ដែលអាចអនុវត្តបាន។',
        'ក្នុងករណីដែលហាងកម្មវិធី (App Store/Play Store) ឬអ្នកផ្តល់សេវាទូទាត់ប្រាក់ផ្សេងទៀតដំណើរការប្រតិបត្តិការទូទាត់ ច្បាប់ស្តីពីការបង់ប្រាក់ ការលុបចោល និងការបង្វិលសងប្រាក់របស់ពួកគេក៏អាចត្រូវបានអនុវត្តផងដែរ។',
      ],
    },
    {
      number: '១៤',
      title: 'សកម្មភាពដែលត្រូវបានហាមឃាត់',
      paragraphs: [
        'អ្នកប្រើប្រាស់មិនត្រូវប្រើប្រាស់ E-School ដើម្បី៖',
        '• វាយប្រហារ ឬចូលលុកលុយ (hack) ប្រព័ន្ធរបស់ E-School;',
        '• ស្វែងរកការចូលប្រើប្រាស់ដោយគ្មានការអនុញ្ញាត;',
        '• គេចវេះពីការគ្រប់គ្រងសុវត្ថិភាព;',
        '• គេចវេះពីការរឹតបន្តឹងវគ្គសិក្សា ឬសេវាកម្ម;',
        '• ក្លែងបន្លំការធ្វើតេស្ត វត្តមាន ពិន្ទុ ឬរបាយការណ៍;',
        '• ចូលប្រើប្រាស់គណនី ឬព័ត៌មានរបស់អ្នកប្រើប្រាស់ផ្សេងទៀត;',
        '• ចែករំលែក ឬចម្លងមេរោគ ឬកម្មវិធីបង្កគ្រោះថ្នាក់ (malware);',
        '• ជេរប្រមាថ ឬធ្វើទុក្ខបុកម្នេញអ្នកប្រើប្រាស់ផ្សេងទៀត;',
        '• ចែកចាយឡើងវិញនូវមាតិកាអប់រំដែលត្រូវបានការពារដោយគ្មានការអនុញ្ញាត;',
        '• ទាញយកផលប្រយោជន៍ពីចន្លោះប្រហោងសុវត្ថិភាព (security vulnerabilities); ឬ',
        '• ធ្វើសកម្មភាពល្មើសច្បាប់នានា។',
      ],
    },
    {
      number: '១៥',
      title: 'ការផ្អាកការចូលប្រើប្រាស់',
      paragraphs: [
        'ប្រសិនបើអ្នកប្រើប្រាស់បំពានលើលក្ខខណ្ឌនៃការប្រើប្រាស់ទាំងនេះធ្ងន់ធ្ងរ ឬច្រើនដង E-School អាច៖',
        '• ចេញការព្រមាន;',
        '• លុបមាតិកាដែលមិនសមរម្យចេញ;',
        '• លុបអ្នកប្រើប្រាស់ចេញពីថ្នាក់រៀនផ្ទាល់ (Live Class);',
        '• រឹតបន្តឹងមុខងារណាមួយ;',
        '• ផ្អាកគណនីជាបណ្តោះអាសន្ន; ឬ',
        '• បញ្ឈប់ការចូលប្រើប្រាស់ទាំងស្រុងក្នុងករណីធ្ងន់ធ្ងរ។',
        'E-School អាចចាត់វិធានការជាបន្ទាន់ក្នុងករណីដែលចាំបាច់ ដើម្បីការពារសិស្ស អ្នកប្រើប្រាស់ផ្សេងទៀត ឬសុវត្ថិភាពរបស់ប្រព័ន្ធ។',
      ],
    },
    {
      number: '១៦',
      title: 'តម្រូវការផ្នែកបច្ចេកទេស',
      paragraphs: [
        'សេវាកម្មមួយចំនួនរបស់ E-School តម្រូវឱ្យមាន៖',
        '• ឧបករណ៍ដែលគាំទ្រសេវាកម្ម;',
        '• ការភ្ជាប់បណ្តាញអ៊ិនធឺណែត;',
        '• កំណែ (version) នៃកម្មវិធី E-School ដែលគាំទ្រ;',
        '• សិទ្ធិចូលប្រើប្រាស់កាមេរ៉ាសម្រាប់មុខងារមួយចំនួន;',
        '• សិទ្ធិចូលប្រើប្រាស់មីក្រូហ្វូនសម្រាប់មុខងារមួយចំនួន; ឬ',
        '• តម្រូវការបច្ចេកទេសផ្សេងទៀត។',
        'ថ្នាក់រៀនផ្ទាល់ និងការទស្សនាវីដេអូអាចតម្រូវឱ្យមានការភ្ជាប់អ៊ិនធឺណែតដែលមានលំនឹងគ្រប់គ្រាន់។',
        'អ្នកប្រើប្រាស់ត្រូវទទួលខុសត្រូវលើឧបករណ៍ និងការភ្ជាប់អ៊ិនធឺណែតផ្ទាល់ខ្លួនរបស់ពួកគេ។',
      ],
    },
    {
      number: '១៧',
      title: 'ការធ្វើបច្ចុប្បន្នភាព E-School',
      paragraphs: [
        'E-School អាចធ្វើបច្ចុប្បន្នភាពកម្មវិធី និងសេវាកម្មរបស់ខ្លួនដើម្បី៖',
        '• បន្ថែមមុខងារសិក្សាថ្មីៗ;',
        '• កែលម្អមុខងារដែលមានស្រាប់;',
        '• បង្កើនសុវត្ថិភាព;',
        '• ដោះស្រាយបញ្ហាបច្ចេកទេស;',
        '• ឆ្លើយតបទៅនឹងតម្រូវការច្បាប់; ឬ',
        '• កែលម្អបទពិសោធន៍នៃការសិក្សា។',
        'កំណែកម្មវិធីចាស់ៗមួយចំនួនអាចនឹងលែងទទួលបានការគាំទ្រនាពេលអនាគត។',
      ],
    },
    {
      number: '១៨',
      title: 'ភាពអាចរកបាននៃសេវាកម្ម',
      paragraphs: [
        'E-School មានគោលបំណងរក្សាសេវាកម្មរបស់ខ្លួនឱ្យមាន និងអាចជឿទុកចិត្តបាន ប៉ុន្តែមិនធានាថាដំណើរការដោយគ្មានការរំខាននោះឡើយ។',
        'សេវាកម្មអាចនឹងមិនអាចប្រើប្រាស់បានម្តងម្កាល ដោយសារតែការថែទាំ ការធ្វើបច្ចុប្បន្នភាព បញ្ហាអ៊ិនធឺណែត ឬហេដ្ឋារចនាសម្ព័ន្ធ សេវាកម្មភាគីទីបី តម្រូវការសុវត្ថិភាព ឬស្ថានភាពផ្សេងៗទៀត។',
      ],
    },
    {
      number: '១៩',
      title: 'គោលការណ៍ឯកជនភាព',
      paragraphs: [
        'លក្ខខណ្ឌនៃការប្រើប្រាស់ទាំងនេះគួរតែត្រូវបានអានរួមគ្នាជាមួយនឹងគោលការណ៍ឯកជនភាពរបស់ E-School។',
        'គោលការណ៍ឯកជនភាពពន្យល់អំពីរបៀបដែល E-School ចាត់ចែងព័ត៌មានផ្ទាល់ខ្លួន រួមមាន៖',
        '• ព័ត៌មានរបស់សិស្ស;',
        '• ព័ត៌មានរបស់មាតាបិតា/អ្នកអាណាព្យាបាល;',
        '• ព័ត៌មានគណនី;',
        '• សកម្មភាពអប់រំ;',
        '• វឌ្ឍនភាពនៃការសិក្សា;',
        '• វត្តមាន;',
        '• ព័ត៌មាននៃការធ្វើតេស្ត និងការវាយតម្លៃ;',
        '• របាយការណ៍សិក្សា;',
        '• ការប្រាស្រ័យទាក់ទង;',
        '• ព័ត៌មានឧបករណ៍ និងបច្ចេកទេស; និង',
        '• ព័ត៌មានផ្សេងទៀតដែលពាក់ព័ន្ធនឹងការប្រើប្រាស់ E-School។',
      ],
    },
    {
      number: '២០',
      title: 'គោលការណ៍ផ្សេងទៀតរបស់ E-School',
      paragraphs: [
        'លក្ខខណ្ឌនៃការប្រើប្រាស់ទាំងនេះក៏គួរតែត្រូវបានអានរួមគ្នាជាមួយនឹងគោលការណ៍ផ្សេងទៀតរបស់ E-School រួមមាន៖',
        '• ខសន្យា និងលក្ខខណ្ឌរបស់ E-School (Terms and Conditions);',
        '• គោលការណ៍ឯកជនភាពរបស់ E-School;',
        '• គោលការណ៍បង្វិលសងប្រាក់ និងការលុបចោលដែលអាចអនុវត្តបាន; និង',
        '• ច្បាប់ជាក់លាក់ណាមួយដែលត្រូវបានផ្តល់ជូនសម្រាប់វគ្គសិក្សា ឬសេវាកម្ម។',
        'ប្រសិនបើមានលក្ខខណ្ឌជាក់លាក់ត្រូវបានផ្តល់ជូនសម្រាប់សេវាកម្មណាមួយ លក្ខខណ្ឌជាក់លាក់ទាំងនោះអាចនឹងត្រូវអនុវត្តបន្ថែមលើលក្ខខណ្ឌនៃការប្រើប្រាស់ទាំងនេះ។',
      ],
    },
    {
      number: '២១',
      title: 'ការផ្លាស់ប្តូរលក្ខខណ្ឌនៃការប្រើប្រាស់ទាំងនេះ',
      paragraphs: [
        'E-School អាចធ្វើបច្ចុប្បន្នភាពលក្ខខណ្ឌនៃការប្រើប្រាស់ទាំងនេះ នៅពេលដែលសេវាកម្ម មុខងារ បច្ចេកវិទ្យា ប្រតិបត្តិការអាជីវកម្ម ឬតម្រូវការផ្លូវច្បាប់មានការផ្លាស់ប្តូរ។',
        'កំណែចុងក្រោយបង្អស់ និងកាលបរិច្ឆេទកែប្រែនឹងត្រូវបានបង្ហាញជូនតាមរយៈ E-School។',
        'សម្រាប់ការផ្លាស់ប្តូរសំខាន់ៗ E-School អាចផ្តល់ការជូនដំណឹងតាមរយៈកម្មវិធី គេហទំព័រ អ៊ីមែល ការជូនដំណឹង (notification) ឬវិធីសាស្ត្រសមស្របផ្សេងទៀត។',
      ],
    },
    {
      number: '២២',
      title: 'ច្បាប់គ្រប់គ្រង',
      paragraphs: [
        'លក្ខខណ្ឌនៃការប្រើប្រាស់ទាំងនេះត្រូវបានគ្រប់គ្រងដោយច្បាប់នៃព្រះរាជាណាចក្រកម្ពុជា ដោយអនុលោមតាមសិទ្ធិជាកំហិតនានាដែលត្រូវបានអនុវត្តក្រោមច្បាប់ជាធរមាន។',
      ],
    },
    {
      number: '២៣',
      title: 'ទាក់ទងមកយើង',
      paragraphs: [
        'សម្រាប់សំណួរ ឬកង្វល់នានាអំពីការប្រើប្រាស់ E-School សូមទាក់ទង៖',
        '<strong>E-School Cambodia</strong>',
        'អ៊ីមែល៖ info@e-schoolcambodia.com<br/>គេហទំព័រ៖ https://e-schoolcambodia.com<br/>អាសយដ្ឋាន៖ អគារការិយាល័យ Kings View, វិថីកែវចិន្តា, ភូមិ៣, សង្កាត់ជ្រោយចង្វារ, ខណ្ឌជ្រោយចង្វារ, ភ្នំពេញ, ព្រះរាជាណាចក្រកម្ពុជា',
        'តាមរយៈការចូលប្រើប្រាស់ ឬការប្រើប្រាស់ E-School អ្នកទទួលស្គាល់ថាអ្នកបានអាន យល់ដឹង និងយល់ព្រមអនុវត្តតាមលក្ខខណ្ឌនៃការប្រើប្រាស់ទាំងនេះ។',
      ],
    },
  ],
};

export default data;
